
import { translateUi } from '@i18n/config';const importMetaEnv =
  typeof import.meta !== "undefined" ? (import.meta as any).env : undefined;
const processEnv =
  typeof process !== "undefined" ? (process as any).env : undefined;
const envSource = { ...(processEnv || {}), ...(importMetaEnv || {}) };

const asBool = (val: unknown) => val === true || val === "true" || val === "1";

/**
 * Real backend mode means stubs must not be used. Driven by env flags:
 * - VITE_REQUIRE_BACKEND=1 (primary)
 * - VITE_ENABLE_MSW=0 (when MSW is disabled)
 * - VITE_USE_STUBS=false/0 (explicit opt-out)
 */
export function isRealBackendMode(): boolean {
  try {
    if (
      typeof window !== "undefined" &&
      (window.localStorage.getItem("VITE_USE_STUBS") === "1" ||
        window.localStorage.getItem("VITE_ENABLE_MSW") === "1")
    )
      return false;
  } catch {}
  if (asBool(envSource?.VITE_REQUIRE_BACKEND)) return true;
  if (envSource?.VITE_USE_STUBS !== undefined)
    return !asBool(envSource?.VITE_USE_STUBS);
  if (envSource?.VITE_ENABLE_MSW !== undefined)
    return !asBool(envSource?.VITE_ENABLE_MSW);
  return false;
}

export function assertStubsAllowed(feature: string): void {
  if (isRealBackendMode()) {
    throw new Error(
      translateUi("value0RequiresRealBackendStubsAreDisabled", "{{value0}} requires real backend; stubs are disabled in this mode.", { value0: feature }),
    );
  }
}
